import { createAction, props } from "@ngrx/store";
import { CollectionOS } from "../../firebase/crypto.service";
import { CachingStatus, ChainType, CryptoWalletWithoutNull, NftAsset } from "./crypto.state";

export const connectWallet = createAction(
    '[Crypto] Connect wallet',
    props<CryptoWalletWithoutNull>()
);

export const disconnectWallet = createAction(
    '[Crypto] Disconnect wallet',
    props<{
        chain: ChainType;
    }>()
);

export const loadNftAssets = createAction(
    '[Crypto] Load NFT assets'
);

export const nftAssetsLoaded = createAction(
    '[Crypto] NFT assets loaded',
    props<{
        nftAssets: NftAsset[]
    }>()
);

export const setLoadingStatus = createAction(
    '[Crypto] Set loading status',
    props<{
        status: CachingStatus
    }>()
);

export const saveFavorites = createAction(
    '[Crypto] Save favorite nfts',
    props<{
        favorites: NftAsset[]
    }>()
);

export const removeFavorites = createAction(
    '[Crypto] Remove favorite nfts'
);

export const addCollections = createAction(
    '[Crypto] Add collections',
    props<{
        collections: CollectionOS[]
    }>()
);

export const clearCryptoState = createAction(
    '[Crypto] Clear Crypto State'
);

export const loadWallet = createAction(
    '[Crypto] Load wallet',
    props<CryptoWalletWithoutNull>()
);
